// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__GWAcL","footer":"ModalFilter_footer__2zy0F"};